import { Icon } from '@iconify/react'
import type { MyDistributorEmptyStateMessage } from '@/lib/my-distributor'
import styles from './SouDistribuidorPage.module.css'

interface MyDistributorEmptyStateProps {
  icon: string
  message: MyDistributorEmptyStateMessage
}

export function MyDistributorEmptyState({ icon, message }: MyDistributorEmptyStateProps) {
  return (
    <div className={styles.centered}>
      <Icon icon={icon} style={{ fontSize: '2rem' }} />
      {message.lines.map((line) => (
        <p key={line}>{line}</p>
      ))}
      {message.authHint ? (
        <p className={styles.authHint}>
          <Icon icon="mdi:account-circle-outline" aria-hidden />
          {message.authHint}
        </p>
      ) : null}
    </div>
  )
}
